import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const MediaWrapper = styled.div<{
  $isTwoColumn?: boolean;
  $forceMaxWidth?: number | null;
}>`
  display: block;
  margin: 0 auto;
  margin-bottom: 16px;

  ${({ $isTwoColumn }) =>
    $isTwoColumn ? `margin-top: 0;` : `margin-top: 0.75rem;`}

  ${({ $isTwoColumn }) =>
    $isTwoColumn ? `min-height: 50px;` : `min-height: 100px;`}

  @media (min-width: ${Breakpoints.b560}px) {
    ${({ $isTwoColumn }) =>
      $isTwoColumn ? `min-height: 70px;` : `min-height: 90px;`}

    ${({ $forceMaxWidth }) =>
      $forceMaxWidth && $forceMaxWidth > 0
        ? `max-width: ${$forceMaxWidth}px;`
        : ''}
  }

  @media (min-width: ${Breakpoints.b960}px) {
    ${({ $isTwoColumn }) =>
      $isTwoColumn ? `min-height: 100px;` : `min-height: 150px;`}
  }
`;

export const MediaImageContainer = styled.div<{ $printMode?: boolean; $isSSR?: boolean }>`
  position: relative;
  width: 100%;
  /* Default aspect ratio placeholder - will be updated when image loads */
  aspect-ratio: 16 / 9;
  background-color: ${({ $isSSR }) => ($isSSR ? 'transparent' : '#f5f5f5')};
  border-radius: 8px;
  overflow: hidden;
`;

// Print/PDF mode: use natural layout (no absolute positioning, no placeholder box).
export const MediaImagePrint = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
`;

export const MediaImage = styled.img<{
  $isLoaded: boolean;
  $printMode?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
  opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

export const MediaVideo = styled.video`
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

export const MediaYouTubeIframe = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;
  border: none;
  border-radius: 8px;
`;

export const MediaCaption = styled.div`
  width: 90%;
  margin: 0 auto;
  margin-top: 16px;
  text-align: center;
`;
